import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-overview-card',
  templateUrl: './overview-card.component.html',
  styleUrls: ['./overview-card.component.scss'],
  standalone: false,
})
export class OverviewCardComponent {
  @Input() number!: number;
  @Input() text!: string;
  @Input() iconKey!: string;
}
